<template>
  <section class="admin new-report__section">
    <h3 class="new-report__heading">ADMIN FIELDS</h3>
    <div class="new-report__input-row">
      <label class="new-report__label" for="incident_type">Incident Type</label>
      <multiselect
        id="incident_type"
        :options="incidentTypes"
        :value="incidentType()"
        placeholder="-- Select Incident Type --"
        name="incidentType"
        class="new-report__input new-report__input--select"
        @input="updateIncidentType"
      />
    </div>
    <div class="new-report__input-row">
      <label class="new-report__label" for="biologist">Biologist</label>
      <input
        id="biologist"
        :value="adminField('biologist')"
        type="text"
        name="biologist"
        class="new-report__input new-report__input--text"
        @change="debounceBiologist"
        @blur="updateBiologist"
      />
    </div>
    <div class="new-report__input-row">
      <label class="new-report__label space-fix" for="biologist_date"
        >Date handled</label
      >
      <client-only>
        <datepicker
          id="biologist_date"
          :value="adminField('dateHandled')"
          name="dateHandled"
          class="new-report__input--date"
          input-class="new-report__date-internal"
          @input="updateDateHandled"
        />
      </client-only>
    </div>
    <div class="new-report__input-row">
      <label class="new-report__label" for="action_taken">Action taken</label>
      <multiselect
        id="action_taken"
        :options="actions"
        :value="actionTaken"
        placeholder="-- Selection Action --"
        label="name"
        track-by="value"
        name="actionTaken"
        class="new-report__input new-report__input--select"
        @input="updateActionTaken"
      />
    </div>
    <div class="new-report__input-row">
      <label class="new-report__label" for="incident-notes">Notes</label>
      <textarea
        id="incident-notes"
        :value="adminField('notes')"
        name="notes"
        class="new-report__input new-report__input--textarea"
        @change="debounceNotes"
        @blur="updateNotes"
      ></textarea>
    </div>
  </section>
</template>

<script>
import { get } from "lodash";
import { debounce } from "lodash";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    Datepicker: () => import("vuejs-datepicker"),
  },
  data() {
    return {
      incidentTypes: [
        "Epizootic Hemorrhagic Disease (EHD)",
        "Chronic Wasting Disease (CWD)",
      ],
      actions: [
        { value: "pending", name: "Pending" },
        { value: "assigned", name: "Assigned to Field for Verification" },
        { value: "dismissed", name: "Dismissed" },
        { value: "confirmed", name: "Confirmed" },
      ],
    };
  },
  computed: {
    actionTaken() {
      // return this.$store.state.incidentReport.admin.actionTaken;
      const action = get(this, "$store.state.incidentReport.admin.actionTaken");
      const selectedObj = this.actions.find((a) => a.value === action);
      return selectedObj;
    },
  },
  methods: {
    incidentType() {
      if (this.$store.state.incidentReport.admin.incidentType === "null") {
        return "";
      } else {
        return this.$store.state.incidentReport.admin.incidentType;
      }
    },
    adminField(field) {
      return this.$store.state.incidentReport.admin[field];
    },
    updateIncidentType(type) {
      const admin = this.$store.state.incidentReport.admin;
      admin.incidentType = type;
      this.$store.commit("incidentReport/setAdmin", admin);
    },
    updateBiologist(event) {
      const admin = $nuxt.$store.state.incidentReport.admin;
      const string = event.target.value;
      admin.biologist = string;
      $nuxt.$store.commit("incidentReport/setAdmin", admin);
    },
    debounceBiologist: debounce((event) => {
      const admin = $nuxt.$store.state.incidentReport.admin;
      admin.biologist = event.target.value;
      $nuxt.$store.commit("incidentReport/setAdmin", admin);
    }, 300),
    updateDateHandled(date) {
      const admin = this.$store.state.incidentReport.admin;
      admin.dateHandled = date;
      this.$store.commit("incidentReport/setAdmin", admin);
    },
    updateActionTaken(action) {
      const admin = this.$store.state.incidentReport.admin;
      admin.actionTaken = action;
      this.$store.commit("incidentReport/setAdmin", admin);
    },
    updateNotes(event) {
      const admin = $nuxt.$store.state.incidentReport.admin;
      const string = event.target.value;
      admin.notes = string;
      $nuxt.$store.commit("incidentReport/setAdmin", admin);
    },
    debounceNotes: debounce((event) => {
      const admin = $nuxt.$store.state.incidentReport.admin;
      const string = event.target.value;
      admin.notes = string;
      $nuxt.$store.commit("incidentReport/setAdmin", admin);
    }, 300),
  },
};
</script>

<style lang="scss" scoped>
client-only {
  width: 100%;
}
.space-fix {
  width: calc(100% / 6);
  @media only screen and (max-width: 375px) {
    width: calc(100% / 2);
  }
}
</style>

<style lang="scss">
.new-report__input {
  &--date {
    width: 90%;
    @media only screen and (max-width: 375px) {
      width: 100%;
    }
    input {
      font-size: 16px;
      font-family: "Gill Sans W03", sans-serif;
      font-weight: 300;
      line-height: 20px;
      color: rbg(53, 73, 94);
    }
  }
  &--textarea {
    font-size: 16px;
    font-family: "Gill Sans W03", sans-serif;
    font-weight: 300;
    color: rbg(53, 73, 94);
  }
}
.admin {
  &__button-container {
    display: flex;
    justify-content: space-around;
    margin-top: 1rem;
  }
  &__button {
    &--update {
      @include button(white, #658250);
      @include light-font;
      font-size: 18px;
      width: calc(100% / 3);
      & ~ & {
        margin-left: 1.5rem;
      }
    }
    &--cancel {
      @include button;
      @include light-font;
      font-size: 18px;
      width: calc(100% / 3);
      & ~ & {
        margin-left: 1.5rem;
      }
    }
  }
}
</style>
